import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { requestDeletion } from "@/api";
import { useUser } from "@/providers/context";

export const useRequestDeletion = () => {
  const { uid } = useUser();
  return useMutation<unknown, AxiosError<{ error: string }, unknown>>(
    async () => {
      if (uid) {
        await requestDeletion({ user_id: uid });
      }
    },
  );
};
